module.exports = __webpack_public_path__ + "img/big.de8521e.svg";